import { render } from "./QR.vue?vue&type=template&id=57eeb986&ts=true"
import script from "./QR.vue?vue&type=script&lang=ts"
export * from "./QR.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/ch-ocean-widget/ch-ocean-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__